import React from "react";

const Megaphone = ({ color }: { color: string }) => {
  return (
    <svg
      width="47"
      height="46"
      viewBox="0 0 47 46"
      fill="none"
      className="svg-megaphone"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6803 26.5551L34.242 26.1079C34.9942 26.0788 35.4458 25.2605 35.0694 24.6086L24.0631 5.54514C23.6868 4.89327 22.7523 4.87521 22.351 5.51205L16.1829 15.3012L22.6803 26.5551Z"
        fill={color}
      />
      <path
        d="M33.1247 13.0223C32.8412 12.5312 33.0095 11.9032 33.5006 11.6196L35.2819 10.5912C35.773 10.3076 36.401 10.4759 36.6846 10.967C36.9681 11.4582 36.7999 12.0862 36.3087 12.3697L34.5274 13.3982C34.0363 13.6817 33.4083 13.5135 33.1247 13.0223Z"
        fill={color}
      />
      <path
        d="M30.7395 6.01548C31.0847 5.56558 31.7293 5.48072 32.1792 5.82593C32.6291 6.17114 32.714 6.8157 32.3688 7.26562L31.1165 8.89779C30.7713 9.34778 30.1266 9.43266 29.6767 9.08737C29.2267 8.74212 29.1419 8.09751 29.4871 7.64758L30.7395 6.01548Z"
        fill={color}
      />
      <path
        d="M38.8823 17.4411C38.9564 18.0034 38.5606 18.5193 37.9983 18.5933L35.9588 18.8618C35.3965 18.9358 34.8807 18.54 34.8066 17.9777C34.7326 17.4154 35.1284 16.8996 35.6907 16.8255L37.7302 16.557C38.2924 16.483 38.8083 16.8788 38.8823 17.4411Z"
        fill={color}
      />
      <path
        d="M14.7417 16.913L8.71256 20.3939C7.75597 20.9462 7.42822 22.1694 7.9805 23.126L8.00814 23.1739L7.7108 23.3455C5.91188 24.3841 5.2933 26.6927 6.3319 28.4916C7.3705 30.2906 9.67909 30.9091 11.478 29.8705L11.7754 29.6989L11.8031 29.747C12.3554 30.7036 13.5786 31.0313 14.5352 30.479L14.7945 30.3293L24.3603 38.7223C25.0044 39.2875 25.9371 39.3795 26.6793 38.951L28.7711 37.7433C29.9629 37.0552 30.1199 35.3971 29.0784 34.4976L20.7328 27.2899L14.7417 16.913Z"
        fill={color}
      />
    </svg>
  );
};
export default Megaphone;
